import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createProductPriceClass,
  deleteProductPriceClass,
  getAllPriceClassSync,
  getProductPriceClassList,
  updateProductPriceClass,
} from "../../services/MoloniServices";

const ProductPriceMoloni = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [productPriceClassList, setProductPriceClassList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [productPriceClassData, setProductPriceClassData] = useState({
    id: "",
    title: "",
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [isProductLoading, setIsProductLoading] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleCheckboxCashChange = (e) => {
    setProductPriceClassData({
      ...productPriceClassData,
      default: e.target.checked ? 1 : 0,
    });
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setProductPriceClassData({
      id: "",
      title: "",
      moloni_id: "",
    });

    setErrors("");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchDocument = () => {
    let data = { ...params };
    getProductPriceClassList(data)
      .then((response) => {
        setProductPriceClassList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchDocument(data);
    },
    [params],
  );

  const handleProductSync = () => {
    setIsProductLoading(true);

    let data = { company_id: "269134" };
    getAllPriceClassSync(data)
      .then((response) => {
        toast.success(response.data.message);
        setIsProductLoading(false);

        let data = { ...params };
        getProductPriceClassList(data)
          .then((response) => {
            setProductPriceClassList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsProductLoading(false);
      });
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const onEditDetails = (e, item) => {
    setModifyModal(true);
    setProductPriceClassData({
      id: item?.id,
      title: item?.title,
      moloni_id: item?.moloni_id,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { price_class_id: delType, company_id: "269134" };
    deleteProductPriceClass(data)
      .then((response) => {
        let data = { ...params };

        fetchDocument(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!productPriceClassData.title) {
      errorObj.title = `title is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      title: productPriceClassData?.title,
    };

    let updateData = {
      company_id: "269134",
      id: productPriceClassData?.id,
      title: productPriceClassData?.title,
      price_class_id: productPriceClassData?.moloni_id,
    };

    if (productPriceClassData?.id) {
      updateProductPriceClass(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchDocument(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setProductPriceClassData({
            id: "",
            title: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createProductPriceClass(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchDocument(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setProductPriceClassData({
            id: "",
            title: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-products")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("priceClasses")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleAddModal}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleProductSync}
                          disabled={isProductLoading}
                        >
                          {isProductLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("title")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {productPriceClassList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.title}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onEditDetails(e, item)
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {productPriceClassList &&
                                productPriceClassList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("title")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {productPriceClassList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.title}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onEditDetails(e, item)
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {productPriceClassList &&
                                productPriceClassList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div
              className="card-footer card-footer-part clearfix card-footer"
              style={{ marginTop: "-26px" }}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_price_classes")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this price classes")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>{t("priceClasses")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("title")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={productPriceClassData.title}
                        onChange={(e) => {
                          setProductPriceClassData({
                            ...productPriceClassData,
                            title: e.target.value,
                          });
                        }}
                        name={`title`}
                        maxLength={50}
                        placeholder="Title"
                      />
                    </div>
                    {errors.title && (
                      <span className="input-error">{errors.title}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ProductPriceMoloni;
